import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "clockBackwardsFilled"
const ClockBackwardsFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M7.755 2.78C10.054 1.628 12.7 1.377 15.175 2.075S19.775 4.37 21.133 6.555C22.49 8.74 22.983 11.352 22.515 13.88 22.045 16.41 20.649 18.67 18.598 20.223S13.992 22.505 11.431 22.269C8.87 22.034 6.49 20.85 4.756 18.95S2.063 14.572 2.063 12H3.937C3.938 14.104 4.724 16.132 6.142 17.686S9.508 20.21 11.603 20.403 15.789 19.997 17.467 18.727 20.287 15.607 20.67 13.538 20.651 9.332 19.541 7.545C18.428 5.76 16.69 4.451 14.665 3.88S10.476 3.514 8.595 4.457C7.211 5.15 6.055 6.207 5.24 7.5H7.384V9.374L2.33 9.375V3.759H4.206V5.709C5.146 4.49 6.355 3.482 7.755 2.78" />
          <path d="M11.438 6.75C12.473 6.75 13.312 7.59 13.312 8.625V11.612L15.088 13.386C15.82 14.12 15.82 15.307 15.087 16.039L11.437 12.388z" />
        </svg>
      }
    </span>
  )
}
export default ClockBackwardsFilledIcon
